import { ButtonGroup, Card, CardBody, Col } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Button, VerticalGroupButton } from "../../../../Constant";
import { VERTICAL_BUTTON_GROUP } from "../../../../Data/Buttons/ButtonGroup";
import CommonDropDown from "./Common/CommonDropDown";

const Vertical = () => {
  return (
    <Col lg="6">
      <Card className="height-equal">
        <CommonCardHeader title={VerticalGroupButton} span={VERTICAL_BUTTON_GROUP} />
        <CardBody className="btn-group-wrapper">
          <ButtonGroup vertical>
            <Btn color="primary">{Button}</Btn>
            <Btn color="secondary">{Button}</Btn>
           <CommonDropDown color="success" />
            <Btn color="info">{Button}</Btn>
            <Btn color="warning">{Button}</Btn>
            <CommonDropDown color="danger" />
            <CommonDropDown color="light" dark />
          </ButtonGroup>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Vertical;
